module.exports = __webpack_public_path__ + "img/logo_repco_nex.2bae4906.svg";